import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";
import { styled } from "@mui/system";

import CategoryPill from "~/components/common/category/CategoryPill";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

const Description = ({ form }: { form: DatabaseDetailPageProps["form"] }) => {
  const theme = useTheme();
  return (
    <div css={rootStyle}>
      <p css={descriptionStyle(theme)}>{form.description}</p>
      <CategoryPillListContainer>
        {form.categories.map((category, index) => (
          <CategoryPill key={index} name={category.name} />
        ))}
      </CategoryPillListContainer>
    </div>
  );
};

const rootStyle = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const descriptionStyle = (theme: Theme) => css`
  margin-right: auto;
  margin-left: 1rem;
  color: ${theme.palette.text.primary};
  font-size: 14px;

  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;

  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
`;

const CategoryPillListContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: "0.25rem",
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: "0.5rem 0 0.5rem 0.5rem",
}));

export default Description;
